import { createSlice } from '@reduxjs/toolkit'

export const ProjectCreationStepSlice = createSlice({
    name : "project_creation_step",
    initialState:{
        value : "Source Material Step 1"
    },
    reducers :{
        projectCreationStepFilter :(state, action)=>{
                state.value = action.payload;
        }
    }

})

export const {projectCreationStepFilter} = ProjectCreationStepSlice.actions

export default ProjectCreationStepSlice.reducer;